
import { supabase } from '@/integrations/supabase/client';
import { logStoreDeleted } from '@/services/activity/activityLogService';
import { analyticsEvents } from '@/services/analytics';

// Delete a store from Supabase
export const deleteStore = async (id: string): Promise<boolean> => {
  // Get store details before deletion
  const { data: store, error: fetchError } = await supabase
    .from('stores')
    .select('*')
    .eq('id', id)
    .single();
    
  if (fetchError) {
    console.error("Error fetching store before deletion:", fetchError);
    throw fetchError;
  }
  
  const { error } = await supabase
    .from('stores')
    .delete()
    .eq('id', id);
  
  if (error) {
    console.error("Error deleting store:", error);
    throw error;
  }
  
  // Log the deletion
  await logStoreDeleted(id, {
    name: store.name,
    address: store.address
  });
  
  // Track store deletion in analytics
  analyticsEvents.store.delete(id, store.name);
  
  return true;
};
